<template>
  <!--
    	作者：kmdshop
    	时间：2019-10-26
    	描述：商品管理-商品编辑-规格/库存
    -->
  <div>
    <!--购买权限-->
    <div class="common-form mt50">商品权限设置</div>
    <el-form-item label="允许查看价格的用户等级">
      <el-select v-model="form.model.setting.buy_auth.show_price_id" multiple style="width: 400px;" placeholder="请选择">
        <el-option
          v-for="item in form.gradeList"
          :key="item.grade_id"
          :label="item.name"
          :value="item.grade_id">
        </el-option>
      </el-select>
      <div class="gray9"> 说明：不填写则为全部用户 </div>
    </el-form-item>
    <el-form-item label="允许购买的用户等级">
      <el-select v-model="form.model.setting.buy_auth.buy_auth_id" multiple style="width: 400px;" placeholder="请选择">
        <el-option
          v-for="item in form.gradeList"
          :key="item.grade_id"
          :label="item.name"
          :value="item.grade_id">
        </el-option>
      </el-select>
      <div class="gray9"> 说明：不填写则为全部用户 </div>
      <div class="red"> 交易设置中,开启全局(购买权限),才能生效 </div>
    </el-form-item>
    <el-form-item label="每月购买数量限制">
      <el-input v-model="form.model.setting.buy_auth.monthLimit" placeholder="每月购买数量限制" class="max-w460"></el-input>
      <div class="gray9"> 说明：不填写则不限购 </div>
    </el-form-item>
    <el-form-item label="无权限提示文字">
      <el-input v-model="form.model.setting.buy_auth.tips" placeholder="提示文字" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="购买无权限时跳转链接">
      <el-input v-model="form.model.setting.buy_auth.name" class="max-w460"></el-input>
      <el-button type="primary" @click="changeLink(index)">选择链接</el-button>
    </el-form-item>
    <SetLink v-if="isLinkSet" :is_linkset="isLinkSet" @closeDialog="closeLinkset">选择链接</SetLink>

  </div>
</template>

<script>
import SetLink from '@/components/setlink/Setlink';
export default {
  components: {
    //跳转链接
    SetLink,
  },
  data() {
    return {
      /*是否选择链接*/
      isLinkSet: false,
    }
  },
  inject: ['form'],
  methods: {

    /*选择链接*/
    changeLink(index) {
      this.isLinkSet = true;
      this.index = index;
    },

    /*获取链接并关闭弹窗*/
    closeLinkset(e) {
      this.isLinkSet = false
      if (e) {
        this.form.model.setting.buy_auth.linkUrl = e.url
        this.form.model.setting.buy_auth.name = '链接到' + ' ' + e.type + ' ' + e.name
        if(e.appid){
          this.form.model.setting.buy_auth.appid = e.appid
        }
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/product/product/part/Auth.vue